<app-header-separat></app-header-separat>
<app-home-banner></app-home-banner>

<!-- de scos de tot -->
<!-- <div class="nottice" id="programari-online">
    <div class="container">
        <div class="row">
            <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-12 text-center">
                Stimati pacienti, avand in situatia existenta la nivelul tarii noastre cauzata de catre virusul COVID-19,
                 toate programarile online sunt din acest moment suspendate. Pentru programari va rog contactati
                 clinica CMDTAMP telefonic utilizand datele din pagina de contact.
            </div>
        </div>
    </div>
</div> -->

<div class="anunt ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2>MASURI GENERALE PENTRU PACIENTI</h2>
                <h3>
                    IN VEDEREA ACORDARII ASISTENTEI MEDICALE PE PERIOADA INFECTIEI CU COVID-19
                </h3>
                <ul>
                    <li>
                        Programarea pacientilor se face in special telefonic/on-line, cu
                        exceptia situatiilor in care acest lucru nu este posibil ( acces limitat la o sursa de
                        comunicare);
                    </li>
                    <li>
                        Programarea pacientilor se face respectand programul medicilor si
                        pauza necesara dezinfectarii cabinetelor/salilor de asteptare;
                    </li>
                    <li>
                        Pacientii programati trebuie sa respecte ora programarii si este
                        interzis a se prezenta la cabinetul medicului mai devreme de cel mult 15 minute inainte de
                        ora programarii;
                    </li>
                    <li>
                        La intrarea in incinta Centrului, pacientii sunt supusi triajului
                        epidemiologic, fiind obligati sa complecteze pe propia raspundere formularul “
                        <strong>Chestionar de triaj epidemiologic primar” ( acest document se poate descarca si de
                            pe pagina de internet a Centrului </strong>.
                            <a target="_blank" href="assets/img/chestionar-de-triaj.png"><strong>Descarca
                                Documentul</strong></a>
                    </li>
                    <li>
                        Accesul pacientilor in incinta institutiei este permis numai daca
                        acesta are masca chirurgicala;
                    </li>
                    <li>
                        Urgentele medico-chirurgicale au access fara programare /bilet de
                        trimitere;
                    </li>
                    <li>
                        Este interzis accesul vizitatorilor si a insotitorilor pacientilor
                        cu exceptia insotitorilor copiilor, persoanelor in vasrta si a celor cu dizabilitati;
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<app-home-about></app-home-about>

<div class="courses-categories-area bg-image pt-100 pb-70">
    <div class="container">
        <div class="section-title text-start">
            <!-- <span class="sub-title">Courses Categories</span>-->
            <h2>Specialitati medicale</h2>
            <a routerLink="/specialitati-medicale" class="default-btn"><i
                    class='bx bx-show-alt icon-arrow before'></i><span class="label">Vezi toate</span><i
                    class="bx bx-show-alt icon-arrow after"></i></a>
        </div>
        <app-home-specialitati></app-home-specialitati>
    </div>
</div>

<!-- <div class="instructor-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Profesionisti Desavarsiti</span>
            <h2>Medicii Nostri</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut nisi ut aliquip ex ea.</p>
        </div>
         <app-home-medici></app-home-medici>
    </div>
</div> -->

<app-bottom-hooks></app-bottom-hooks>
